<template>
    <img class="thumbnail__partner-logo"
         :srcset="`${getPartnerLogo().x1} 1x, ${getPartnerLogo().x2} 2x`"
         :src="getPartnerLogo().x1"
         alt=""
         v-if="getPartnerLogo()"
    />
</template>

<script>
export default {
    name: 'thumbnail-partner-logo',
    props: {
        course: {
            type: Object,
            required: true
        }
    },
    methods: {
        getPartnerLogo () {
            if (this.course.thumbnailOptions?.usePartnerLogo && this.course.thumbnail.partnerLogoUrl !== null && this.course.thumbnail.partnerLogoUrl !== undefined) {
                return {
                    x1: this.course.thumbnail.partnerLogoUrl.x1,
                    x2: this.course.thumbnail.partnerLogoUrl.x2
                }
            }

                return false
            }
        }
    }
</script>

<style lang="scss" scoped>
    .thumbnail {
        &__partner-logo {
            position: absolute;
            right: 10px;
            bottom: 10px;
            z-index: 997;
            max-width: 120px;
            max-height: 60px;

            [class*="mobile"] & {
                max-width: 100px;
                max-height: 45px;
            }
        }
    }
</style>
